/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function useTrackOrderFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        orderNo: {
            name: `${prefix}orderNumber`,
            label: formatMessage({
                defaultMessage: 'Order Number',
                id: 'use_track_order_fields.label.order_number'
            }),
            defaultValue: '',
            type: 'text',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter order number.',
                    id: 'use_track_order_fields.error.required_order_number'
                })
            },
            error: errors?.[`${prefix}orderNumber`],
            control
        },
        email: {
            name: `${prefix}orderEmail`,
            label: formatMessage({
                defaultMessage: 'Order Email',
                id: 'use_track_order_fields.label.order_email'
            }),
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter email address.',
                    id: 'use_track_order_fields.error.required_email'
                }),
                pattern: {
                    value: /^\S+@\S+\.\S+$/, // simple email regex
                    message: formatMessage({
                        defaultMessage: 'Please enter valid email address.',
                        id: 'use_track_order_fields.error.valid_email'
                    })
                }
            },
            error: errors?.[`${prefix}orderEmail`],
            control
        },
        zipcode: {
            name: `${prefix}zipCode`,
            label: formatMessage({
                defaultMessage: 'Billing Zip Code',
                id: 'use_track_order_fields.label.billing_zip_code'
            }),
            defaultValue: '',
            type: 'number',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter billing zip code.',
                    id: 'use_track_order_fields.error.billing_zip_code'
                }),
                pattern: {
                    value: /^(\d{5}(-\d{4})?)$/, // Regex for validating 5-digit or 9-digit zip codes
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid zip code.',
                        id: 'use_track_order_fields.error.valid_zip_code'
                    })
                }
            },
            error: errors?.[`${prefix}zipCode`],
            control
        }
    }
    return fields
}
